<template>
  <div class="TextInput">
    <label :for="fname"
      ><template v-if="$te(label)">{{ $t(label) }}</template
      ><template v-else>{{ label }}</template></label
    >
    <Icon class="required" v-if="required" icon="asterisk" />
    <input
      :type="type"
      :disabled="disabled"
      :id="fname"
      :name="fname"
      :placeholder="translate(placeholder)"
      class="form-control"
      v-on:blur="blur"
      :value="modelValue"
      v-on:input="updateValue($event.target.value)"
    />
    <div v-if="explanation && errors.length === 0" class="explanation">
      <small>{{ $t(explanation) }}</small>
    </div>
    <transition name="slidedown">
      <div v-if="errors.length && (!untouched || showAllErrors)" class="validationErrors">
        <small v-for="error in errors" v-bind:key="error">
          <template v-if="$te(error)">
            {{ $t(error) }}
          </template>
          <template v-else>
            {{ error }}
          </template>
        </small>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '../Icon.vue';

export default {
  name: 'TextInput',
  emits: ['update:modelValue', 'blur', 'input'],
  components: {
    Icon,
  },
  data() {
    return {
      untouched: true,
    };
  },
  computed: {
    ...mapState({
      showAllErrors: (state) => state.showAllValidationErrors,
    }),
  },
  props: {
    modelValue: { default: '' },
    label: { default: '' },
    fname: { default: '' },
    type: { default: 'text' },
    disabled: { default: false },
    placeholder: { default: undefined },
    explanation: { default: false },
    errors: {
      default() {
        return [];
      },
    },
    required: { default: false },
  },
  methods: {
    blur() {
      this.untouched = false;
      this.$emit('blur');
    },
    updateValue(val) {
      this.$emit('update:modelValue', val);
      this.$emit('input', val);
    },
    translate(v) {
      if (typeof v === 'undefined') {
        return '';
      }
      return this.$t(v);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('update:modelValue', this.modelValue);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/form';
.TextInput {
  @extend .form-group;
}
.required :deep(.icon .fill) {
  fill: $state-danger-text !important;
}
</style>
